import { Component, Input, TemplateRef } from '@angular/core';
import {
  EoViewComponentDescriptor,
  EoViewPanelConfig,
} from './eo-view-panel-config.model';
import { IViewComponent } from '../eo-base-view/i-view-component';
import { EoViewComponentTypeEnum } from '../eo-base-view/eo-view-component-type-enum';

@Component({
  selector: 'eo-view-panel',
  templateUrl: './eo-view-panel.component.html',
  styleUrl: './eo-view-panel.component.scss',
})
export class EoViewPanelComponent {
  EoViewComponentTypeEnum = EoViewComponentTypeEnum;

  @Input() config!: EoViewPanelConfig;
  @Input() headerTemplate?: TemplateRef<any>;

  constructor() {}

  getComponentType(component: EoViewComponentDescriptor) {
    return component.componentType;
  }

  getComponentLabel(component: EoViewComponentDescriptor): any {
    return component.label;
  }

  getComponentValue(component: EoViewComponentDescriptor): any {
    return component.value;
  }

  // Date
  getComponentDateFormat(component: EoViewComponentDescriptor): any {
    return component.dateFormat;
  }

  // Currency
  getComponentDecimalDigits(component: EoViewComponentDescriptor): any {
    return component.decimalDigits;
  }

  getComponentCurrencyFormat(component: EoViewComponentDescriptor): any {
    return component.currencyFormat;
  }

  // Label
  getComponentToolTipPosition(component: EoViewComponentDescriptor): any {
    return component.toolTipPosition;
  }
  
  getComponentToolTipText(component: EoViewComponentDescriptor): any {
    return component.toolTipText;
  }
  getComponentIcon(component: EoViewComponentDescriptor): any {
    return component.icon;
  }
  getComponentSeverity(component: EoViewComponentDescriptor): any {
    return component.severity;
  }

  getColumnClass(): string {
    let columns =
      this.config.columnsNum && this.config.columnsNum > 0
        ? this.config.columnsNum
        : 2;

    let numColumns = `col-${12 / columns}`;

    return numColumns;
  }
}
